import { Features, QuestionType } from '../../../generated/hooks';
import type { NewReportData } from '../types';
import type { ReportComponent, ReportDefinitionDocument } from './types';

export function generateDefaultDefinition(report: NewReportData): ReportDefinitionDocument {
  const components: ReportComponent[] = [{ id: 'response-rate', type: 'responseRate', width: 'full' }];
  if (report.metadata.organization.featureNames?.includes(Features.AiSummaryOfSurveyAndPhase)) {
    components.unshift({ id: 'ai-summary', type: 'aiSummary' });
  }
  if (
    report.responses.some(
      (response) => response.anonymous || response.originalAnonymous || response.additionallyAnonymized,
    )
  ) {
    components.push({ id: 'anonymity-rate', type: 'anonymityRate', width: 'full' });
  }
  report.questions
    .filter((question) =>
      [QuestionType.Select, QuestionType.Multiselect, QuestionType.Scale, QuestionType.Freetext].includes(
        question.type,
      ),
    )
    .slice()
    .sort(
      (a, b) =>
        (a.reportOrder ?? Number(a.index)) - (b.reportOrder ?? Number(b.index)) ||
        a.index.localeCompare(b.index, undefined, { numeric: true }),
    )
    .forEach((question) =>
      components.push({
        id: `question-${question.index}`,
        type: 'question',
        questionIndex: question.index,
        width: 'full',
      }),
    );
  return { schemaVersion: 1, metrics: [], pages: { overview: { components } } };
}
